import React, { Component } from 'react';
import FormExplanationValidation from './FormExplanationValidation';
import { isEmpty } from '../Utilities/JsonFunctions';

class FormCheckbox extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {
        this.props.onChange(e);
    }

    render() {
        let requiredMark = this.props.required ? <span className="required-mark">*</span> : null;
        let text = isEmpty(this.props.link) ? this.props.text : <a href={this.props.link} target="_blank" rel="noopener noreferrer">{this.props.text}</a>;

        return (
            <div className="tr">
                <div className="FieldLabel td">
                    <label htmlFor={this.props.id}>
                        {text}
                        {requiredMark}
                    </label>
                </div>
                <div className="EditingFormValueCell td">
                    <span className="CheckBoxField checkbox">
                        <input type="checkbox" id={this.props.id} onChange={this.handleChange} checked={this.props.value} />
                        <label htmlFor={this.props.id}>&nbsp;</label>
                    </span>
                    <FormExplanationValidation explanation={this.props.explanation} showValidation={this.props.showValidation} validationText={this.props.validationText} />
                </div>
            </div>
        );
    }
}

export default FormCheckbox;


// WEBPACK FOOTER //
// ./src/Fields/FormCheckbox.js